@if (model()?.length > 0) {
  @if (header()) {
    <h3 class="mt-3">
      <strong>{{ header() }}</strong>
    </h3>
  }
  <table class="table table-sm">
    <thead>
      <tr>
        @for (column of bodyColumns()(model()[0]); track column.label) {
          <th [colSpan]="column.colSpan || 1" [class]="column.cssClass" [ngClass]="cssClass(column)">
            {{ column.label }}
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (line of model(); track line) {
        <tr>
          @for (column of bodyColumns()(line); track column.label) {
            <td [colSpan]="column.colSpan || 1" [class]="column.cssClass" [ngClass]="cssClass(column)">
              @if (column.bold) {
                <strong><span [innerHTML]="column.value"></span></strong>
              } @else {
                <span [innerHTML]="column.value"></span>
              }
            </td>
          }
        </tr>
        @if (bodySubTableColumnsProperty() && line[bodySubTableColumnsProperty()]?.length > 0) {
          <tr>
            <td class="p-0 ps-5" [colSpan]="bodyColumns()(line).length === 1 ? 1 : bodyColumns()(line).length - 1">
              <app-report-table
                [model]="line[bodySubTableColumnsProperty()]"
                [bodyColumns]="bodySubTableColumns()"
              ></app-report-table>
            </td>
          </tr>
        }
        @if (bodySubTableItemsProperty() && line[bodySubTableItemsProperty()]?.length > 0) {
          <tr>
            <td>
              <app-report-value-pairs
                [summaryItems]="bodySubTableItems()(line[bodySubTableItemsProperty()])"
              ></app-report-value-pairs>
            </td>
          </tr>
        }
        @if (bodySubTableItemsProperty2() && line[bodySubTableItemsProperty2()]?.length > 0) {
          <tr>
            <td>
              <app-report-value-pairs
                [summaryItems]="bodySubTableItems()(line[bodySubTableItemsProperty2()])"
              ></app-report-value-pairs>
            </td>
          </tr>
        }
        @if (bodySubTableColumnsProperty2() && line[bodySubTableColumnsProperty2()]?.length > 0) {
          <tr>
            <td class="p-0 ps-5">
              <app-report-table
                [model]="line[bodySubTableColumnsProperty2()]"
                [bodyColumns]="bodySubTableColumns2()"
              ></app-report-table>
            </td>
          </tr>
        }
        @if (extraSubLineBreak() && line[bodySubTableColumnsProperty()]?.length > 0) {
          <br />
        }
        @if (extraBoldLine()) {
          <tr>
            <td [colSpan]="bodyColumns()(model()[0]).length" class="p-0">
              <hr />
            </td>
          </tr>
        }
      }
      @if (extraLineBreak()) {
        <br />
      }
      @if (footerColumns()) {
        <ng-container class="footer">
          <tr>
            @for (column of footerColumns()(footerModel()); track column.label) {
              <td [colSpan]="column.colSpan || 1" [class]="column.cssClass" [ngClass]="cssClass(column)">
                <strong>{{ column.label }}</strong>
                @if (column.label && column.value) {
                  <br />
                }
                @if (column.bold) {
                  <strong><span [innerHTML]="column.value"></span></strong>
                } @else {
                  <span [innerHTML]="column.value"></span>
                }
              </td>
            }
          </tr>
          @if (footerSubTableColumnsProperty() && footerModel()[bodySubTableColumnsProperty()]?.length > 0) {
            <tr>
              <td class="p-0 ps-5" [colSpan]="footerColumns()(footerModel()).length">
                <app-report-table
                  [model]="footerModel()[footerSubTableColumnsProperty()]"
                  [footerColumns]="footerSubTableColumns()"
                ></app-report-table>
              </td>
            </tr>
          }
        </ng-container>
      }
    </tbody>
  </table>
}
